document.addEventListener('DOMContentLoaded', () => {
  if (typeof subscribe === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') return;

  const section = document.querySelector('[data-manufacturer-details]');
  if (!section) return;

  const { productId } = section.dataset;
  const rows = [...section.querySelectorAll('[data-batch-row]')];
  if (rows.length === 0) return;

  subscribe(PUB_SUB_EVENTS.variantChange, (data) => {
    if (data.productId !== productId || !data.variant) return;

    for (const row of rows) {
      const isSelected = row.dataset.variantId === String(data.variant.id);
      row.classList.toggle('manufacturer-details__row-data--selected', isSelected);
      row.classList.toggle('bg-[rgba(249,249,249,1)]', isSelected);
      row.classList.toggle('bg-white', !isSelected);
    }
  });
});
